import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WorkAssignmentLayer from "../components/WorkAssignmentLayer";

const WorkAssignmentPage = () => {
  return (
    <MasterLayout pageTitle="Work Assignment">
      <WorkAssignmentLayer />
    </MasterLayout>
  );
};

export default WorkAssignmentPage;
